export default __webpack_public_path__ + "locales/sl/SendInviteDialog.json?hash=46ef94770c6183e04eb6c94d6af61186";